
import React from "react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useDebugReviewsManagement } from "@/hooks/useDebugReviewsManagement";
import { DebugReviewsTable } from "@/components/admin/reviews/DebugReviewsTable";
import { DebugReviewDetailDialog } from "@/components/admin/reviews/DebugReviewDetailDialog";
import { Separator } from "@/components/ui/separator";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { Bug, RefreshCw, Info } from "lucide-react";

export const DebugReviewsTab = () => {
  const {
    isLoading,
    reviews,
    isDetailOpen,
    setIsDetailOpen,
    selectedReview,
    deleteReviewMutation,
    handleDeleteReview,
    handleHighlightToggle,
    handleRefresh,
    handleViewDetails,
    isRefreshing,
    deleteStatus,
  } = useDebugReviewsManagement();

  return (
    <div className="space-y-6">
      <Card>
        <CardHeader className="pb-3">
          <div className="flex justify-between items-center">
            <div>
              <CardTitle className="text-xl flex items-center gap-2">
                <Bug className="h-5 w-5" />
                Reviews Debug Mode
              </CardTitle>
              <CardDescription>
                Isolated environment for testing review management functionality
              </CardDescription>
            </div>
            <Button 
              variant="outline" 
              size="sm" 
              onClick={handleRefresh}
              disabled={isRefreshing}
            >
              <RefreshCw className={`h-4 w-4 mr-2 ${isRefreshing ? 'animate-spin' : ''}`} />
              Refresh Data
            </Button>
          </div>
        </CardHeader>
        <CardContent className="space-y-4">
          <Alert variant="info" className="bg-blue-50">
            <Info className="h-4 w-4" />
            <AlertTitle>Debug Information</AlertTitle>
            <AlertDescription>
              This page is designed to isolate and test review management functionality, particularly deletion.
              All operations are logged to the console to help diagnose issues.
            </AlertDescription>
          </Alert>

          {deleteStatus && (
            <Alert variant={deleteStatus.success ? "default" : "destructive"} className={deleteStatus.success ? "bg-green-50" : ""}>
              <AlertTitle>{deleteStatus.success ? "Success" : "Error"}</AlertTitle>
              <AlertDescription>
                {deleteStatus.message}
              </AlertDescription>
            </Alert>
          )}

          <Separator />
          
          <div className="rounded-md border">
            <DebugReviewsTable 
              isLoading={isLoading}
              reviews={reviews}
              onDelete={handleDeleteReview}
              onViewDetails={handleViewDetails}
            />
          </div>
        </CardContent>
      </Card>

      <DebugReviewDetailDialog 
        isOpen={isDetailOpen}
        onOpenChange={setIsDetailOpen}
        selectedReview={selectedReview}
        onDelete={handleDeleteReview}
        onHighlightToggle={handleHighlightToggle}
      />
    </div>
  );
};
